import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "./assets/css/ionicons.min.css";
import "./assets/scss/style.scss";
import router from "./router";
import store from "./store";
import bus from "./utils/bus";

// import VConsole from 'vconsole';

// const vConsole = new VConsole();
// vConsole.destroy();

const app = createApp(App);
app.config.globalProperties.$bus = bus;

app.use(ElementPlus).use(store).use(router).mount("#app");
